import { BinaryTreeEdit } from './binary-tree-edit';
import { BTNMETA, BTNPAR } from './binary-tree-node';
import { CoordinatorService } from './coordinator.service';

export type BTENPAR = {
    id?: string;
    meta?: BTNMETA;
    childLs?: BTENPAR[];
    bte?: BinaryTreeEdit;
    parent?: BinaryTreeEditNode;
    level?: number;
    ech?: boolean;
    isRoot?: boolean;
};

export class BinaryTreeEditNode {
    id: string;
    meta: BTNMETA;
    bte: BinaryTreeEdit;
    parent: BinaryTreeEditNode | undefined;
    level: number;
    isExpanded = false;
    isRoot: boolean;
    showDescription = false;
    script?: string;

    private _childLs: BinaryTreeEditNode[] = [];

    constructor(
        private coords: CoordinatorService,
        params: BTENPAR,
    ) {
        this.id = params.id || this.coords.uniqueId();
        this.bte = params.bte!;
        this.meta = params.meta || {};
        this.level = params.level || 0;
        this.parent = params.parent;
        this.isRoot = params.isRoot === undefined || params.isRoot;

        params.childLs?.forEach((child) => {
            child.parent = this;
            child.level = this.level + 1;
            child.bte = this.bte;
            child.isRoot = false;
            this._childLs.push(new BinaryTreeEditNode(coords, child));
        });
    }

    get btnPar(): BTNPAR {
        return {
            id: this.id,
            meta: this.meta,
            childLs: this._childLs.filter((child) => child.title).map((x) => x.btnPar),
        };
    }

    get isLeaf() {
        const stop = this.bte.meta!.type == 'tags' ? 5 : 1;
        return this.level > stop;
    }

    getScript() {
        return this.script || '';
    }

    submitScript(data: string) {
        console.log('submitScript', data);
    }

    get title() {
        if (this.isRoot) return this.bte.title;
        return this.meta.title?.trim() || '';
    }

    set title(val: string) {
        if (this.isRoot) this.bte.title = val;
        else this.meta.title = val;
    }

    isDisabledMove(tp: 'up' | 'down') {
        if (!this.parent) return false;
        const ls = this.parent?.childLs;
        return (tp == 'up' && ls[0] === this) || (tp == 'down' && ls[ls.length - 1] === this);
    }

    switchExpand() {
        this.isExpanded = !this.isExpanded;
    }

    toggleDescription() {
        this.showDescription = !this.showDescription;
    }

    move(tp: 'up' | 'down') {
        const ls = this.parent?.childLs;
        const i = ls!.indexOf(this);
        const j = tp == 'up' ? i - 1 : i + 1;
        ls?.splice(i, 1);
        ls?.splice(j, 0, this);
    }

    delete() {
        const ls = this.parent?.childLs;
        const i = ls!.indexOf(this);
        ls!.splice(i, 1);
    }

    get hint() {
        if (this.isRoot) {
            return 'ratingsTitle';
        }
        if (this.level == 1) {
            return 'optionTitle';
        }
        if (this.level == 2) {
            return 'reasonTitle';
        }
        return '';
    }

    get description() {
        return this.meta.description || '';
    }

    set description(val: string) {
        this.meta.description = val;
    }

    get childLsLength() {
        return this.childLs?.filter((x) => x.title).length || 0;
    }

    get childLs() {
        const ln = this._childLs.length;

        if (!ln || this._childLs[ln - 1].title)
            this._childLs.push(
                new BinaryTreeEditNode(this.coords, {
                    level: this.level + 1,
                    parent: this,
                    isRoot: false,
                    bte: this.bte,
                }),
            );
        return this._childLs;
    }
}
